import React, { useEffect, useState } from 'react'
import './login-box.scss'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { IonCard, IonCardContent, IonInput, IonItem, IonLabel, IonLoading, IonRadio, IonRadioGroup, IonText } from '@ionic/react'
import { Link } from 'react-router-dom'
import { ILoginBoxProps } from '.'
import { routeService } from 'services'
import { useTranslation } from 'react-i18next'
import { BaseButton } from 'components/base-button'
import i18next from 'i18n'

const SPID_URL = process.env.REACT_APP_SPID_URL

const validationSchema = Yup.object().shape({
  user: Yup.string().required(i18next.t('form_validator.required')),
  password: Yup.string().required(i18next.t('form_validator.required')),
})

const LoginBox: React.FC<ILoginBoxProps> = ({ onLoginSubmit, submitted, genericError }) => {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      user: '',
      password: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      onLoginSubmit(values.user, values.password)
      setLoading(false)
    },
  })

  useEffect(() => {
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        formik.handleSubmit()
      }
    })
  })

  return (
    <IonCard className="edisu-login-box">
      <IonCardContent className="login-cnt">
        <IonLoading isOpen={loading} message={t('loading')} />
        <form onSubmit={formik.handleSubmit}>
          <div className="form-control">
            <IonLabel className="form-label" position="stacked">
              {t('username').toUpperCase()}
            </IonLabel>
            <IonInput
              value={formik.values.user}
              onIonInput={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder={t('username')}
              name="user"
            />
            <IonLabel color="danger" className={formik.touched.user && formik.errors.user ? '' : 'hidden'}>
              {formik.touched.user && formik.errors.user ? formik.errors.user : ''}
            </IonLabel>
          </div>
          <div className="form-control">
            <IonLabel className="form-label" position="stacked">
              {t('password').toUpperCase()}
            </IonLabel>
            <IonInput
              placeholder={t('password')}
              onIonInput={formik.handleChange}
              onBlur={formik.handleBlur}
              type="password"
              value={formik.values.password}
              name="password"
            />
            <IonLabel color="danger" className={formik.touched.password && formik.errors.password ? '' : 'hidden'}>
              {formik.touched.password && formik.errors.password ? formik.errors.password : ''}
            </IonLabel>
          </div>

          <IonText className={'generic-error' + (genericError ? ' show' : '')} color="danger">
            {genericError || 'placeholder'}
          </IonText>
          <div className="bottom">
            <div className="submit-cnt">
              <BaseButton type="submit" label={t('login')} disabled={submitted} />
            </div>
            <div className="forgot">
              <Link to={routeService.generateRoutePath('/reset-pw')}>{t('forgot_password')}</Link>
            </div>
          </div>
        </form>
        <div className="spid">
          <p className="edisu-text-1">{t('own_spid')}</p>
          <p className="edisu-text-2">{t('login_with_spid')}</p>
          <br />
          <a href={SPID_URL}>
            <img src="/assets/img/SPIDCIE.png" alt="spid_button" />
          </a>
        </div>
      </IonCardContent>
    </IonCard>
  )
}

export default LoginBox
